import Picture from "@/components/common/Picture";
import TextField from "@/components/site-builder/TextField";
import { type TestimonialBlock } from "../types";
import s from "./TestimonialVariant1.module.scss";

export interface TestimonialVariant1Props {
  block: TestimonialBlock;
}

export default function TestimonialVariant1(props: TestimonialVariant1Props) {
  const { block } = props;
  const { name, company, jobTitle, text, headline, logo } = block;

  return (
    <div className={s.block}>
      <div className={s.inner}>
        <div className={s.details}>
          <TextField field={name} type="text-large" />
          <TextField field={jobTitle} type="text-large" />
          <TextField field={company} type="text-large" />
          <Picture imageConfig={logo} />
        </div>
        <div className={s.content}>
          <TextField field={headline} type="header-h4" />
          <TextField field={text} type="text-large" />
        </div>
      </div>
    </div>
  );
}
